import { Box } from '@material-ui/core';
import { useMemo } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { Multilender } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/Multilender';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface PaymentIntentFactoryProps {
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
  onOpenMerchantPos: () => void;
}

export const PaymentIntentFactory = ({ paymentMethodDetailEntity, onOpenMerchantPos }: PaymentIntentFactoryProps) => {
  const { ref, width } = useWidth<HTMLDivElement>();

  const allowedToCompleteOnboarding = paymentMethodDetailEntity.isAgentAllowedToCompleteOnboarding();
  const shouldCreatePaymentIntent = useMemo(
    () => paymentMethodDetailEntity.shouldCreatePaymentIntent(),
    [paymentMethodDetailEntity],
  );

  if (!allowedToCompleteOnboarding) {
    return <NotAllowedToCompleteOnboarding />;
  }

  const isSmall = width && width < 500;

  return (
    <CustomPaper fill="paper">
      <div ref={ref}>
        <Box
          gridGap={24}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection={isSmall ? 'column' : 'row'}
        >
          <FlexColumn gridGap={4}>
            <Font variant="subtitle1" color="textPrimary" display="block">
              <Text strong tId={shouldCreatePaymentIntent ? 'START_PAYMENT_METHOD' : 'CONTINUE_APPLICATION'} />
            </Font>
            <Font variant="body2" color="textPrimary">
              <Text
                tId={shouldCreatePaymentIntent ? 'START_PAYMENT_METHOD_DESCRIPTION' : 'CONTINUE_APPLICATION_TEXT'}
              />
            </Font>
          </FlexColumn>
          <Box flexShrink={0}>
            <Multilender
              paymentMethodDetailEntity={paymentMethodDetailEntity}
              onOpenMerchantPos={onOpenMerchantPos}
            />
          </Box>
        </Box>
      </div>
    </CustomPaper>
  );
};

const NotAllowedToCompleteOnboarding = () => {
  return (
    <CustomPaper fill="paper">
      <Box display="flex" width="100%" gridGap={24}>
        <FlexColumn gridGap={4} flexGrow={1} minWidth={300}>
          <Font variant="body2" color="textPrimary" display="block">
            <Text strong tId={'CONTINUE_APPLICATION'} />
          </Font>
          <Font variant="body2" color="textPrimary" display="block">
            <Text tId={'CUSTOMER_CONTINUE_APPLICATION_TEXT'} />
          </Font>
        </FlexColumn>
      </Box>
    </CustomPaper>
  );
};
